import { Box, Group, ScrollArea } from '@mantine/core';
import type { AiAttachment } from '../../../api/hooks/ai/useAIConversation';
import { Attachment } from './Attachment';

export function Attachments({
	attachments,
	onAttachmentRemove,
}: {
	attachments: AiAttachment[];
	onAttachmentRemove: (attachment: AiAttachment) => void;
}) {
	return (
		<Box pt="xs">
			<ScrollArea>
				<Group h={52} spacing="3xs" noWrap>
					{attachments.map((attachment) => (
						<Attachment
							key={attachment.url}
							title={attachment.filename}
							href={attachment.url}
							onRemove={() => onAttachmentRemove(attachment)}
						/>
					))}
				</Group>
			</ScrollArea>
		</Box>
	);
}
